var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contenido over-x-h",class:{'over-y-a': _vm.Scroll,'over-y-h': !_vm.Scroll , 'animate__animated animate__faster animate__fadeIn': _vm.Animar}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }